/**
 * Desgins Queries
 */
import gql from 'graphql-tag'

export const desginsQuery = gql`
  query inspirations($styleId: Int!) {
    inspirations: getInspirationByStyle(styleId: $styleId) {
      name
      image
      colors
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MobileDesignCenterInspiration/data.ts